export default {"src":"/_next/static/media/CoolBit.45fea48a.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};